<template>
    <section class="test-drive">
        <div class="select-model__container container">
            <StepBar :step="2" step-name="Select a model" />

            <Navigation :go-to-step="{ name: 'select-brand' }" />

            <h2 class="title">Please select a model</h2>

            <div class="card">
                <div class="card__inner">

                    <loading-spinner v-if="loading"></loading-spinner>
                    <ul class="select-model__grid" v-else>
                        <div class="select-model__grid--item" v-for="model in newModelsWithElectricSeparated" :key="model.id">
                            <a :href="getRouteUrl(model)" v-if="model.display_on_electric_vehicles == 1 || model.display_on_hybrid_vehicles == 1">
                                <div :class="(model.display_on_electric_vehicles == 1 || model.display_on_hybrid_vehicles == 1) ? 'select-model__feel-electric' : ''">
                                    <picture v-if="model.image">
                                        <source v-if="model.image_webp" :srcset="model.image_webp" type="image/webp" />
                                        <img class="select-model__match-card img-responsive select-model__image" :src="model.image" :alt="model.model_title" />
                                    </picture>
                                </div>
                                <div class="select-model__feel-electric-logo" v-if="model.display_on_electric_vehicles == 1 || model.display_on_hybrid_vehicles == 1">
                                    <picture >
                                        <source srcset="/images/new-models/24hr-test-drive/feel-electric.webp" type="image/webp" />
                                        <img class="img-responsive select-model__logo" src="/images/new-models/24hr-test-drive/feel-electric.jpg" alt="feel-electric" />
                                    </picture>
                                </div>
                                <div v-else class="select-model__feel-electric-spacer"></div>
                                <p class="select-model__title capitalise">{{ model.model_title.replace("Citroen", "Citroën") }}</p>
                            </a>
                            <router-link v-else :to="{ name: 'select-options', params: {brand: brand, urlModel: model.url_model}}">
                                <div>
                                    <picture v-if="model.image">
                                        <source v-if="model.image_webp" :srcset="model.image_webp" type="image/webp" />
                                        <img class="select-model__match-card img-responsive select-model__image" :src="model.image" :alt="model.model_title" />
                                    </picture>
                                </div>
                                <div class="select-model__feel-electric-spacer"></div>
                                <p class="select-model__title capitalise">{{ model.model_title.replace("Citroen", "Citroën") }}</p>
                            </router-link>
                        </div>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import StepBar from "../components/StepBar";
import LoadingSpinner from "../components/LoadingSpinner";
import Navigation from "../components/Navigation";
import { mapState } from "vuex";
import EventObject from "../../modules/tracking/EventObject";

export default {
    props: {
        brand: {
            required: true,
        },
    },
    components: {
        LoadingSpinner,
        StepBar,
        Navigation,
    },
    data() {
        return {
            loading: true,
            newModels: [],
        };
    },
    created() {
        this.$store.commit('setElectricOrHybridSelected', true);
    },
    mounted() {
        axios.get(`/api/test-drive/brand/${this.brand}`, {
                params: {
                    electric: this.$store.state.onlyElectric,
                }
            })
            .then((response) => {
                this.newModels = response.data.data;
                this.loading = false;
            })
            .catch((error) => {
                console.error(error);
                this.$router.push({ name: "select-brand", });
            });

        if (this.step2Page === true) {
            new EventObject("New Car - Test Drive Form", "Revisit", "Step 2 Page").dispatch();
        } else {
            new EventObject("New Car - Test Drive Form", "Visited", "Step 2 Page").dispatch();
            this.$store.commit("setStep2Page", true);
        }
    },
    methods: {
        getRouteUrl(model){
            return `/electric-vehicles/24-hour-test-drive/${this.brand}/${model.url_model}`
        }
    },
    computed: {
        ...mapState(["step2Page"]),
        newModelsWithElectricSeparated() {
            const newModelsWithElectricSeparated = [];
            this.newModels.forEach(newModel => {
                if (typeof newModel.nonElectricAvailable == 'undefined') {
                    newModelsWithElectricSeparated.push(newModel);
                    return;
                }
                if (newModel.nonElectricAvailable !== true) {
                    newModelsWithElectricSeparated.push(newModel);
                    return;
                }
                const nonElectricVersion = JSON.parse(JSON.stringify(newModel));
                nonElectricVersion.id = nonElectricVersion.id + '_2';
                nonElectricVersion.display_on_electric_vehicles = 0;
                nonElectricVersion.display_on_hybrid_vehicles = 0;
                newModelsWithElectricSeparated.push(nonElectricVersion);
                newModelsWithElectricSeparated.push(newModel);
            });
            return newModelsWithElectricSeparated;
        }
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/test-drive/pages/step-2.vue